import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeleteDatasheetSectionComponent } from './delete-datasheet-section.component';
import { DeleteButtonModule } from 'src/app/views/shared/components/buttons/delete-button/delete-button.module';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';



@NgModule({
  declarations: [
    DeleteDatasheetSectionComponent
  ],
  imports: [
    CommonModule,

    //internal modules
    DeleteButtonModule,

    //sweet alert
    SweetAlert2Module.forRoot(),
  ],
  exports: [
    DeleteDatasheetSectionComponent
  ]
})
export class DeleteDatasheetSectionModule { }
